import { render } from "./Information.vue?vue&type=template&id=d16f0f68&scoped=true"
import script from "./Information.vue?vue&type=script&lang=ts"
export * from "./Information.vue?vue&type=script&lang=ts"

import "./Information.vue?vue&type=style&index=0&id=d16f0f68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d16f0f68"

export default script